module.exports = __webpack_public_path__ + "img/yoga_search_not_found.cc875117.png";